import React from 'react';
import styles from '../../../stylesheets/theme/bootstrap_scope.module.scss';

export default function ReportThumbnail({ reports, tripleThumb=true }) {

    const titleSizingClass = () => {
        if(reports.some((report) => report?.title?.length >= 80)) return styles['report-title-sm'];
        if(reports.some((report) => report?.title?.length > 50 && report.title.length < 80)) return styles['report-title-md'];
    }


    const TITLE_SIZE_CLASS = titleSizingClass();
    const REPORT_COUNT = reports.length;
    const MAX_REPORT_THUMBS = 3;
    let bundleClass = `report-bundle-${Math.min(REPORT_COUNT, MAX_REPORT_THUMBS)}`;

    return (
        <div className={`d-flex align-items-center ${styles['d-flex']} ${styles['align-items-center']}`}>
            { reports.map( (report, i) => {
                return (
                    <div className={`report_image ${styles['report_image']} ${ tripleThumb ? `report-triple-thumb ${styles['report-triple-thumb']}` : `${bundleClass} ${styles[bundleClass]}`}`} key={`thumb_${i}`}>
                        <div className={`report-inner-wrapper ${styles['report-inner-wrapper']}`}>
                            <div className={`report-cover-txt ${styles['report-cover-txt']}`}>
                                <div className={`report-subtext ${styles['report-subtext']}`}>
                                    Buyer's Guide
                                </div>
                                <div className={`report-title ${styles['report-title']} ${TITLE_SIZE_CLASS}`}>
                                    {report.title}
                                </div>
                                <div className={`report-subtext ${styles['report-subtext']}`}>
                                    {report.date}
                                </div>
                            </div>
                            <div className={`ps-logo ${styles['ps-logo']}`}>
                                <img src={'https://images.peerspot.com/image/upload/v1688035040/peerspot_logo_lt.png'} width={70} height={21} />
                            </div>
                        </div>
                    </div>
                )}
            )}
        </div>
    )
}